import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'
import small_logo from 'assets/img/logo/logo-small.svg'
import {routes} from 'routes/routes'
import DateRangeIcon from '@mui/icons-material/DateRange'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import ArticleIcon from '@mui/icons-material/Article'

export const Menu = () => {
  const {t} = useI18n()
  return (
    <>
      <div className="logo-details">
        <span>
          <LocalLink to={routes.root} aria-label="home">
            <img
              style={{width: '100%', height: '100%', maxHeight: '50px'}}
              className="logo__white"
              src={small_logo}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
        <span>
          <LocalLink to={routes.root} aria-label="home_big">
            <img
              style={{width: '180px', height: 'auto'}}
              className="log__smnall"
              src={process.env.PUBLIC_URL + '/logo-dark.svg'}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
      </div>
      <div className="sidebar__inner simple-bar">
        <div className="dlabnav">
          <ul className="metismenu">
            <li>
              <LocalLink to={routes.root} aria-label="events">
                <i>
                  <DateRangeIcon />
                </i>
                <span className="nav-text">{t('menu.events')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.info} aria-label="info">
                <i>
                  <TipsAndUpdatesIcon />
                </i>
                <span className="nav-text">{t('menu.whatIsEventa')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.prices} aria-label="help">
                <i>
                  <LocalOfferIcon />
                </i>
                <span className="nav-text">{t('menu.prices')}</span>
              </LocalLink>
            </li>
            <li className="sidebar__nav-hide-narrow">
              <LocalLink to={routes.organizations} aria-label="help">
                <i>
                  <CorporateFareIcon />
                </i>
                <span className="nav-text">{t('menu.forOrganizations')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.affiliates} aria-label="help">
                <i>
                  <QueryStatsIcon />
                </i>
                <span className="nav-text">{t('menu.affiliate')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.blog.root} aria-label="blog">
                <i>
                  <ArticleIcon />
                </i>
                <span className="nav-text">{t('common.blog')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.help} aria-label="help">
                <i>
                  <LiveHelpIcon />
                </i>
                <span className="nav-text">{t('menu.help')}</span>
              </LocalLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
